var globalStore = {
  customerId: null,
};

export default globalStore;
